import { render, staticRenderFns } from "./IntHtKeyword.vue?vue&type=template&id=2c89bca4&scoped=true&"
import script from "./IntHtKeyword.vue?vue&type=script&lang=js&"
export * from "./IntHtKeyword.vue?vue&type=script&lang=js&"
import style0 from "./IntHtKeyword.vue?vue&type=style&index=0&id=2c89bca4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89bca4",
  null
  
)

export default component.exports